import { motion } from "framer-motion";
import SEO from "@assets/images/Monitoring-SEO-performance.avif";

import SEO2 from "@assets/images/SEO-professional.avif";
import SEO3 from "@assets/images/Illustration-of-a-person-working-on-SEO.avif";
import { TiTick } from "react-icons/ti";
export const SpecializedSEOServices = () => {
  return (
    <section className="container space-y-14">
      <section className="flex flex-col lg:flex-col space-y-0">
        <div className="w-full lg:w-full flex flex-col md:flex-row justify-center items-center md:px-6 xl:px-7 space-y-10  md:space-x-10">
          <img
            src={SEO} 
            alt="Monitoring-SEO-performance"
            className="w-[14rem] md:w-[16rem] lg:w-[20rem]"
            width={10} height={10}
          />
          <div className="space-y-5">
            {" "}
            <motion.h2
              initial={{ opacity: 0, y: 40 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.8, ease: "easeOut" }}
              viewport={{ once: true, amount: 0.3 }}
              className="text-[30px] md:text-[35px] lg:text-[40px] xl:text-[45px] 2xl:text-[45px] md:text-5xl font-bold text-dark font-butler text-center md:text-start"
            >
              Specialized SEO Services We Offer{" "}
            </motion.h2>
            <p className="text-base leading-[1.625rem] text-dark text-center md:text-start">
              Our strategies are designed to capture every type of search user,
              from the local prospect looking for a nearby service to the
              enterprise customer conducting deep research. We offer tailored
              SEO solutions to match your business's scale and ambition.
            </p>
          </div>
        </div>
        <div className="w-full lg:w8/12 flex flex-col justify-center md:px-6 xl:px-7 space-y-3 ">
          <div>
            <div className="flex items-start  text-base md:text-lg">
              <span className="text-dark mr-2 bg-[#FFC067] rounded-full p-0.5 mt-0.5 md:mt-1">
                <TiTick />
              </span>
              <div>

              <h3 className="text-lg font-bold text-dark inline">
                Local SEO:{" "}
              </h3>
                 <p className="text-base leading-[1.625rem] text-dark inline">
                As experts in local SEO for small businesses, we ensure your
                company is the first choice for customers in Great Falls and all
                surrounding areas. We implement effective local SEO strategies
                including Google My Business (GMB) optimization, local link
                building, citation management and generating high-quality local
                reviews.
              </p>
              </div>
            </div>
            <div>
           
            </div>
          </div>
          <div>
            <div className="flex items-start text-base md:text-lg">
              <span className="text-dark mr-2 bg-[#FFC067] rounded-full p-0.5 mt-0.5 md:mt-1">
                <TiTick />
              </span>
              <div>

              <h3 className="text-lg font-bold text-dark inline">
                Enterprise SEO:{" "}
              </h3>
              <p className="text-base leading-[1.625rem] text-dark inline">
              For large organizations and high-traffic websites, we provide
              specialized enterprise SEO services. Our focus is on technical
              efficiency, scalable SEO strategies, and managing large-scale
              content inventories. We handle the complexity of large-site
              architecture, international targeting, and deep data analysis
              required to succeed in competitive global markets.
            </p>
              </div>
            </div>
            
          </div>
          <div>
            <div className="flex items-start  text-base md:text-lg">
              <span className="text-dark mr-2 bg-[#FFC067] rounded-full p-0.5 mt-0.5 md:mt-1">
                <TiTick />
              </span>
              <div>

              <h3 className="text-lg font-bold text-dark inline">
                AEO (Answer Engine Optimization):{" "}
              </h3>
                   <p className="text-base leading-[1.625rem] text-dark inline">
              The search results page is no longer just ten blue links. AEO
              ensures your brand appears prominently in knowledge panels, rich
              snippets, and featured snippets. By mastering semantic search and
              structured data, we position your business to dominate voice
              search queries and gain direct visibility in user answers.
            </p>
              </div>
            </div>
       
          </div>
          <div>
            <div className="flex items-start  text-base md:text-lg">
              <span className="text-dark mr-2 bg-[#FFC067] rounded-full p-0.5 mt-0.5 md:mt-1">
                <TiTick />
              </span>
              <div>

              <h3
               
                className="text-lg font-bold text-dark inline"
              >
                GEO (Generative Engine Optimization):{" "}
              </h3>
               <p className="text-base leading-[1.625rem] text-dark inline">
              Future-proof your brand by ensuring visibility in AI-driven
              search. As a tech-forward company, we specialize in emerging GEO
              strategies designed to ensure your content is authoritative,
              trustworthy, and positioned to appear in LLMs (Large Language
              Models) and other new AI search features, preparing you for the
              next generation of discovery.
            </p>
                </div>
            </div>
           
          </div>
        </div>
      </section>
      <section className="flex flex-col ">
        <div className="md:px-6 xl:px-7 mx-auto md:w-11/12 lg:w-10/12 xl:w-8/12 ">
          {" "}
            <div className="w-full lg:w-4/12  block md:hidden flex-col justify-center items-center">
            <img
              src={SEO2}
              alt="SEO-professional"
              className="w-[14rem] md:w-[16rem] lg:w-[20rem] mx-auto "
              width={10} height={10}
            />
          </div>
          <div className="space-y-5 pt-10">

          <motion.h2
            initial={{ opacity: 0, y: 40 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8, ease: "easeOut" }}
            viewport={{ once: true, amount: 0.3 }}
              className="text-[30px] md:text-[35px] lg:text-[40px] xl:text-[45px] 2xl:text-[45px] md:text-5xl font-bold text-dark font-butler text-center "
          >
            Core SEO Techniques We Utilize
          </motion.h2>
          <p className="text-base leading-[1.625rem]  text-dark text-center">
            Effective SEO Techniques rely on a blend of technical finesse,
            content authority, and external credibility. Our comprehensive
            approach covers all types of SEO required for top search engine
            performance.
          </p>
            </div>
        </div>
        <div className="flex flex-col lg:flex-row-reverse space-y-5">
          <div className="w-full lg:w-4/12  hidden md:flex flex-col justify-center items-center">
            <img
              src={SEO2}
              alt="SEO-professional"
              className="w-[14rem] md:w-[16rem] lg:w-[20rem] mx-auto "
              width={10} height={10}
            />
          </div>
          <div className="w-full lg:w-8/12 flex flex-col justify-center  md:px-6 xl:px-7 space-y-3 ">


            <div>
                  <div className="flex items-start  md:items-start text-base md:text-lg">
                     <span className="text-dark mr-2 bg-[#FFC067] rounded-full p-0.5 mt-0.5 md:mt-1">
                  <TiTick />
                </span>

            <div>
              
              <h3 className="text-lg font-bold text-dark inline">
                Technical SEO:{" "}
              </h3>
              <p className="text-base leading-[1.625rem] text-dark inline">
                We execute crucial technical SEO services that govern how search
                engine bots crawl, index, and rank your website. This includes
                optimizing site speed, maintaining Core Web Vitals performance,
                implementing correct canonicalization, and structuring data to
                minimize crawl budget waste and maximize site health.
              </p>
            </div>
</div>
            </div>

 <div> 

              <div className="flex items-start  md:items-start text-base md:text-lg">
                <span className="text-dark mr-2 bg-[#FFC067] rounded-full p-0.5 mt-0.5 md:mt-1">
                  <TiTick />
                </span>

            <div>

              <h3 className="text-lg font-bold text-dark inline">
                On-Page SEO:{" "}
              </h3>
              <p className="text-base leading-[1.625rem] text-dark inline">
                This is where content meets search intent. We optimize every
                page element to align perfectly with your target user's needs.
                Our on-page SEO optimization focuses on high-quality content
                that adheres to E-E-A-T (Experience, Expertise,
                Authoritativeness, and Trustworthiness) principles.
              </p>
            </div>
            </div>
            </div>

 <div> 

              <div className="flex items-start  md:items-start text-base md:text-lg">
                <span className="text-dark mr-2 bg-[#FFC067] rounded-full p-0.5 mt-0.5 md:mt-1">
                  <TiTick />
                </span>

            <div>
              <h3
                 
                className="text-lg font-bold text-dark inline"
              >
                Off-Page SEO:{" "}
              </h3>
              <p className="text-base leading-[1.625rem] text-dark inline">
                Off-page SEO builds your website's domain authority and trust
                signals. Our proactive SEO strategies focus on ethical,
                white-hat link building and brand mentions across the web. We
                focus on acquiring high-quality backlinks that demonstrate
                genuine authority to search engines.
              </p>
            </div>
            </div>
            </div>
          </div>
        </div>
      </section>



      <section className="flex flex-col space-y-0 ">
        <div className="w-full  flex flex-col md:flex-row  justify-center items-center   md:px-6 xl:px-7 space-y-10  md:space-x-10">
          <img
            src={SEO3}
            alt="Illustration-of-a-person-working-on-SEO"
            className="w-[14rem] md:w-[16rem] lg:w-[18rem]"
            width={10} height={10}
          />
          <div className="space-y-5">
            {" "}
            <motion.h2
              initial={{ opacity: 0, y: 40 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.8, ease: "easeOut" }}
              viewport={{ once: true, amount: 0.3 }}
              className="text-[30px] md:text-[35px] lg:text-[40px] xl:text-[45px] 2xl:text-[45px] md:text-5xl font-bold text-dark font-butler text-center md:text-start"
            >
              SEO Essentials We Master
            </motion.h2>
            <p className="text-base leading-[1.625rem] text-dark text-center md:text-start">
              We believe success lies in the details of the SEO strategy
              consulting. Our expertise goes deeper than surface-level
              optimization to ensure your foundation is built for long-term
              organic SEO growth and authority.
            </p>
          </div>
        </div>

        <div className="flex lg:flex-row">
          <div className="w-full flex flex-col justify-center  md:px-6 xl:px-7 space-y-3 ">
            <div> 

              <div className="flex items-start  md:items-start text-base md:text-lg">
                <span className="text-dark mr-2 bg-[#FFC067] rounded-full p-0.5 mt-0.5 md:mt-1">
                  <TiTick />
                </span>
                <div>

                <h3 className=" text-lg font-bold text-dark inline">
                  Advanced Keyword Research:{" "}
                </h3>    <p className="text-base leading-[1.625rem] text-dark inline">
                The foundation of any profitable strategy is knowing exactly
                what your customers are searching for. We perform in-depth
                keyword research, moving beyond basic terms to identify
                high-intent, long-tail phrases that drive qualified traffic and
                contribute to your CRO (Conversion Rate Optimization) goals.
              </p>
                </div>
              </div>
          
            </div>
            <div>
              <div className="flex items-start  md:items-start text-base md:text-lg">
                <span className="text-dark mr-2 bg-[#FFC067] rounded-full p-0.5 mt-0.5 md:mt-1">
                  <TiTick />
                </span>
                <div>

                <h3 className="text-lg font-bold text-dark inline">
                  Competitor Analysis:{" "}
                </h3>
                 <p className="text-base leading-[1.625rem] text-dark inline">
                Understanding the competitive landscape is crucial in crowded
                markets. Our comprehensive competitor analysis identifies
                keyword gaps and link-building opportunities, allowing us to
                build a strategic roadmap that secures your business a position
                at the top of the SERPs.
              </p>
                </div>
              </div>
             
            </div>
            <div>
              <div className="flex items-start  md:items-start text-base md:text-lg">
                <span className="text-dark mr-2 bg-[#FFC067] rounded-full p-0.5 mt-0.5 md:mt-1">
                  <TiTick />
                </span>
                <div>

                <h3 className="text-lg font-bold text-dark inline">
                  SEO Content Writing:{" "}
                </h3>
                 <p className="text-base leading-[1.625rem] text-dark inline">
                Our content marketing & SEO copywriting focuses on meeting user
                intent while achieving topical authority and forming topic
                clusters. We craft authoritative content designed for humans
                first.
              </p>
                </div>
              </div>
             
            </div>
            <div>
              <div className="flex items-start  md:items-start text-base md:text-lg">
                <span className="text-dark mr-2 bg-[#FFC067] rounded-full p-0.5 mt-0.5 md:mt-1">
                  <TiTick />
                </span>
                <div>

                <h3
                
                  className="text-lg font-bold text-dark inline"
                  >
                  AI Visibility: {" "}
                </h3>
                 <p className="text-base leading-[1.625rem] text-dark inline">
                We actively work to increase AI visibility which involves
                structured data implementation and building content trust
                signals that position your brand to be featured by generative AI
                models and answer engines.
              </p>
                  </div>
              </div>
             
            </div>
            <div>
              <div className="flex items-start  md:items-start text-base md:text-lg">
                <span className="text-dark mr-2 bg-[#FFC067] rounded-full p-0.5 mt-0.5 md:mt-1">
                  <TiTick />
                </span>
                <div>

                <h3
                
                  className="text-lg font-bold text-dark inline"
                  > 
                  Strategic Link Building:{" "}
                </h3>
                 <p className="text-base leading-[1.625rem] text-dark inline">
                We employ ethical, white-hat techniques for backlink
                acquisition, moving beyond simple outreach to focus on
                high-quality, relevant domain authority and brand mentions that
                significantly improve your Off-Page SEO profile.
              </p>
                  </div>
              </div>
             
            </div>
            <div>
              <div className="flex items-start  md:items-start text-base md:text-lg">
                <span className="text-dark mr-2 bg-[#FFC067] rounded-full p-0.5 mt-0.5 md:mt-1">
                  <TiTick />
                </span>
<div>

                <h3
                  
                  className="text-lg font-bold text-dark inline"
                >
                  Mobile Optimization:{" "}
                </h3>
                 <p className="text-base leading-[1.625rem] text-dark inline">
                60% of searches now occur on mobile devices. We ensure fast
                loading times, responsive design, and an excellent mobile user
                experience (UX) for critical traffic.
              </p>
                  </div>
              </div>
             
            </div>
          </div>
        </div>
      </section>
    </section>
  );
};
